// requires polyfills for IE and other old browsers
import '@babel/polyfill'
import 'window-location-origin'
import 'whatwg-fetch'

import './stylesheets/app.less'
import React from 'react'
import { initialize as fptiInitialize } from 'lib/fpti_analytics'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { configureStore } from './redux/store'
import { getJSONFromScript, getDataAttr } from './lib/server_params'
import poolsRouter from './router'
import ComingSoonDialog from 'components/coming_soon_dialog'
import SessionTimeout from 'components/session_timeout'
import { startErrorTracking } from 'lib/errors'
import routes from 'server_routes'

function renderMainView() {
  configureStore(getJSONFromScript('store'), store => {
    let PoolsRouter = poolsRouter(store)
    render(
      <Provider store={store}>
        <div>
          {/* TODO: Remove this */}
          <ComingSoonDialog />
          <SessionTimeout />
          <PoolsRouter />
        </div>
      </Provider>,
      document.getElementById('main')
    )
  })
}

function main(/* int argc, char *argv[] */) {
  startErrorTracking(routes.error())

  fptiInitialize()

  // since errors are rendered in the server-side, don't activate react rendering when there is one.
  if (!getDataAttr('error')) {
    renderMainView()
  }
}

main()
